// extracted by mini-css-extract-plugin
export default {"group-title":"_jhn5aB11o4McywelOhi","group-title-text":"YcPsk_rqCpYZ3m5qPYMi","rule":"SxZjcR13aUycoQT7C0t2"};